module.exports = __webpack_public_path__ + "img/elckerlijc.03deb359.jpg";